import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import { Auth } from 'aws-amplify'


// configure router
const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let user;
    Auth.currentSession().then(data => {
      if (data && data.signInUserSession) {
        user = data;
      }
      next()
    }).catch((e) => {
      next({
        path: '/login'
      });
    });
  }
  //If authenticated user goes to login or register, send them to dashboard.
  //Invite acceptance and password reset must stay reachable while signed in
  //(an invitee may be logged in as someone else); those pages handle it.
  const openAuthPages = ['AcceptInvite', 'ResetPassword', 'ForgotPassword']
  if(to.matched.some(record => record.name == "Authentication") && !openAuthPages.includes(to.name)) {

    Auth.currentSession().then(data => {
      if (data && data.idToken) {
        next({
          path: '/'
        });
      }
    }).catch((e) => {
      next();
    });
  }
  next()
})

// Safety net for body scroll locks that outlive their overlay. Page-level
// modals, drawers, and swals lock body scroll while open and release it on
// close; if one is still open when the route changes it is destroyed without
// running that close branch, so no page can scroll until a hard reload. After
// navigation settles, release the lock only when no overlay is actually on
// screen, so layout-level overlays (trial-ended modal, POS drawer) keep theirs.
// Element UI popups restore their own body class on destroy and are not touched.
const OPEN_OVERLAY_SELECTOR = [
  '.modal.show',
  '.base-drawer-overlay',
  '.base-alert-overlay',
  '.booking-drawer-overlay',
  '.objective-drawer-overlay',
  '.swal2-container.swal2-shown'
].join(', ');

router.afterEach(() => {
  Vue.nextTick(() => {
    if (document.querySelector(OPEN_OVERLAY_SELECTOR)) return;
    document.body.style.overflow = '';
    [document.documentElement, document.body].forEach(el => {
      el.classList.remove('modal-open', 'swal2-shown', 'swal2-height-auto');
    });
  });
});

export default router;
